import React, { useState } from 'react';
import { AppBar, Toolbar, Container, Box, Button, IconButton, Drawer, List, ListItem, ListItemButton, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import logo from '../../../img/nekrodruk-logo-dark.png';

const menuItems = [
    { label: 'Oferta', to: '/#Offer' },
    { label: 'Czym jest aplikacja?', to: '/#WhatIs' },
    { label: 'Jak korzystać?', to: '/#HowToUse' },
    { label: 'Kontakt', to: '/#Contact' },
];

export default function Nav() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    const renderMenuButtons = (variant = 'text', onClick) => (
        menuItems.map(({ label, to }) => (
            <Button
                key={to}
                component={HashLink}
                smooth
                to={to}
                onClick={onClick}
                variant={variant}
                sx={{
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: '1rem',
                    color: variant === 'text' ? '#1D1D1F' : '#5189B0',
                    '&:hover': {
                        color: variant === 'text' ? '#5189B0' : '#63b3be',
                        backgroundColor: variant === 'contained' ? '#e3f7f9' : 'transparent',
                    },
                }}
            >
                {label}
            </Button>
        ))
    );

    return(
        <>
            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    background: 'linear-gradient(90deg, rgba(255,255,255,0.95) 0%, rgba(227,247,249,0.95) 100%)',
                    backdropFilter: 'blur(12px)',
                    borderBottom: '1px solid rgba(81, 137, 176, 0.1)',
                    color: '#1D1D1F',
                }}
            >
                <Container maxWidth="lg">
                    <Toolbar disableGutters sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: { xs: 72, md: 88 } }}>
                        <Box component={NavLink} to="/" sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                            <Box
                                component="img"
                                src={logo}
                                alt="logo nekrodruk"
                                sx={{ height: { xs: 36, md: 48 } }}
                            />
                        </Box>
                        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 }}>
                            {renderMenuButtons()}
                            <Button
                                component={NavLink}
                                to="/login"
                                variant="contained"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    borderRadius: 2,
                                    px: 3,
                                    py: 1,
                                    backgroundColor: '#5189B0',
                                    boxShadow: '0 10px 30px rgba(81, 137, 176, 0.25)',
                                    '&:hover': {
                                        backgroundColor: '#63b3be',
                                        boxShadow: '0 12px 30px rgba(99, 179, 190, 0.35)',
                                    },
                                }}
                            >
                                Zaloguj się
                            </Button>
                        </Box>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => setMenuOpen(true)}
                            sx={{ display: { xs: 'flex', md: 'none' } }}
                            aria-label="Otwórz menu"
                        >
                            <MenuIcon />
                        </IconButton>
                    </Toolbar>
                </Container>
            </AppBar>

            <Drawer
                anchor="right"
                open={menuOpen}
                onClose={closeMenu}
                PaperProps={{
                    sx: {
                        width: 280,
                        backgroundColor: '#FFFFFF',
                        backgroundImage: 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(227,247,249,0.95) 100%)',
                        padding: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                    },
                }}
            >
                <Box display="flex" justifyContent="flex-end">
                    <IconButton onClick={closeMenu} aria-label="Zamknij menu">
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Divider sx={{ borderColor: 'rgba(81, 137, 176, 0.2)' }} />
                <List sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {menuItems.map(({ label, to }) => (
                        <ListItem key={to} disablePadding>
                            <ListItemButton
                                component={HashLink}
                                smooth
                                to={to}
                                onClick={closeMenu}
                                sx={{
                                    borderRadius: 2,
                                    color: '#1D1D1F',
                                    textAlign: 'center',
                                    '&:hover': {
                                        backgroundColor: 'rgba(81, 137, 176, 0.1)',
                                        color: '#5189B0',
                                    },
                                }}
                            >
                                {label}
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
                <Divider sx={{ borderColor: 'rgba(81, 137, 176, 0.2)' }} />
                <Button
                    component={NavLink}
                    to="/login"
                    variant="contained"
                    onClick={closeMenu}
                    sx={{
                        mt: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '1rem',
                        borderRadius: 2,
                        py: 1.2,
                        backgroundColor: '#5189B0',
                        boxShadow: '0 12px 30px rgba(81, 137, 176, 0.25)',
                        '&:hover': {
                            backgroundColor: '#63b3be',
                            boxShadow: '0 14px 32px rgba(99, 179, 190, 0.35)',
                        },
                    }}
                >
                    Zaloguj się
                </Button>
            </Drawer>
        </>
    );
}
